import React, {Component} from 'react';
import TextField from '@material-ui/core/TextField';
import {withStyles} from "@material-ui/core";
import Card from "../../common/Card";
import {convertISODateTimeToBRLocale} from "../../common/Util";

const styles = theme => ({
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(1) * 2,
    }
});


class RaspaCycles extends Component {
    constructor(props) {
        super();
        const { cycles } = props;

    }
    renderCycle(cic){
        console.log('cic', cic);
       return(<div> {cic.Data}

       <tr>
                 <td>{cic.Data}</td>
                 <td>{cic.Data}</td>
                 <td>{cic.Usuario}</td>
                 <td>{cic.ReceitaID}</td>
                 <td>Largura</td>
                 <td>Raio</td>
                 <td>Perimetro</td>
                 <td>Angulo Ombro</td>
                 <td>Compr. Ombro</td>
                 <td>Raio Ombro</td>
                 <td>Tempo Ciclo</td>
                 <td>Tempo Espera Oper</td>
                 <td>Fabricante da Serra</td>
                 <td>Consumo Energia</td>
       </tr></div>);
    }

    render() {
        const { cycles } = this.props;
        console.log('Raspacycles', cycles);
        if (cycles == null || cycles.length == 0) {
            return (<React.Fragment/>);
        }
        return (<div>
                <Card style={{flexGrow:12, flexBasis:'100%', justifyContent:'space-between', marginTop: '10px' }}>
                    <table border="0">
                        <tr>
                            <th>Data</th>
                            <th>Operação</th>
                            <th>Usuario</th>
                            <th>Receita</th>
                            <th>Largura</th>
                            <th>Raio</th>
                            <th>Perimetro Final</th>
                            <th>Angulo Ombro</th>
                            <th>Compr. Ombro</th>
                            <th>Raio Ombro</th>
                            <th>Tempo Ciclo</th>
                            <th>Tempo Espera Oper</th>
                            <th>Fabricante da Serra</th>
                            <th>Contador da Serra</th>
                        </tr>
                        {cycles.map( (cic,ix) =>{

                            let operacao ="";
                            switch(cic.tipoCiclo) {
                                case 2:
                                    operacao = 'Limpeza';
                                    break;
                                case 3:
                                    operacao = 'Ajuste Banda'
                                    break;
                                default:
                                    operacao = 'Raspagem'
                            }
                          return( <tr key={ix}>
                              <td>{convertISODateTimeToBRLocale(cic.dataInicio)}</td>
                              <td>{operacao}</td>
                              <td>{cic.usuario}</td>
                              <td>{cic.ReceitaID}</td>
                              <td>{cic.recLargura}</td>
                              <td>{cic.recRaio}</td>
                              <td>{cic.recPerimetroFinal}</td>
                              <td>{cic.recOmbroAngulo}</td>
                              <td>{cic.recOmbroComp}</td>
                              <td>{cic.recOmbroRaio}</td>
                              <td>{cic.tempoCiclo}</td>
                              <td>{cic.tempoEsperaOper}</td>
                              <td>{cic.serraFabricante}</td>
                              <td>{cic.contadorSerraRaspagem}</td>
                          </tr>)
                        })}

                    </table>
                </Card>
        </div>);
    }
}
export default (withStyles(styles, {withTheme: true}))(RaspaCycles);
